import { render, staticRenderFns } from "./default-banner.vue?vue&type=template&id=6ce2bc00&"
import script from "./default-banner.vue?vue&type=script&lang=ts&"
export * from "./default-banner.vue?vue&type=script&lang=ts&"
import style0 from "./default-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports